import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({ providedIn: 'root' })
export class SoftwareUpdateService {
  private endpoint = environment.apiEndpoint;

  constructor(private http: HttpClient) { }

  getSoftwares(
    limit?: number,
    offset?: number,
    orderColumn?: string,
    orderDirection?: 'asc' | 'desc',
    filters?: { [key: string]: any }
  ): Observable<any> {
    let url = `${this.endpoint}/v1/software/version/list`;
    const params = new URLSearchParams();

    if (limit !== undefined) params.append('limit', limit.toString());
    if (offset !== undefined) params.append('offset', offset.toString());
    if (orderColumn) params.append('orderColumn', orderColumn);
    if (orderDirection) params.append('orderDirection', orderDirection);

    if (filters) {
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined) {
          if (Array.isArray(filters[key]) && filters[key].length > 0) {
            const filterObj = filters[key][0];
            if (filterObj?.value !== null && filterObj.value !== undefined && filterObj.value !== '') {
              params.append(key, filterObj.value);
            }
          }
          else if (typeof filters[key] === 'object' && filters[key].value !== null && filters[key].value !== undefined) {
            params.append(key, filters[key].value);
          }
          else if (typeof filters[key] === 'string') {
            params.append(key, filters[key]);
          }
        }
      });
    }

    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    return this.http.get(url);
  }

  getFamilies(platform?: string): Observable<any> {
    return this.http.get(`${this.endpoint}/v1/software/families${platform ? '?platform=' + platform : ''}`);
  }

  uploadSoftwareRequest(
    family?: string,
    model?: string,
    versionNumber?: string,
    sha256?: string,
    fileSize?: number,
    environment?: string,
    description?: string,
    fileName?: string
  ): Observable<any> {
    const body = {
      family,
      model,
      versionNumber,
      sha256,
      fileSize,
      environment,
      description,
      fileName,
    };
    return this.http.put(`${this.endpoint}/v1/software/upload/request`, body);
  }

  editSoftwareInfo(id: string, userId: string, payload: { description?: string; model?: string }): Observable<any> {
    return this.http.post(
      `${this.endpoint}/v1/software/upload/update?userId=${userId}`,
      {
        id,
        ...payload,
      }
    );
  }

  deleteSoftware(id: string): Observable<any> {
    return this.http.delete(`${this.endpoint}/v1/software/version/delete?id=${id}`);
  }
}
